import { TOGGLE_BACK_TO_RECENT_TORCH_ADDRESS , RESET_BACK_TO_RECENT_TORCH_ADDRESS} from "./displayGetBackToRecentTorchAddressReducer"

export const toggleGetBackToRecentTorchAddress = (obj) => ({
    type: TOGGLE_BACK_TO_RECENT_TORCH_ADDRESS,
    payload: obj
})

export const resetGetBackToRecentTorchAddress = () => ({
    type: RESET_BACK_TO_RECENT_TORCH_ADDRESS,
})